import Menu from 'components/Menu/index.js'

export default class MainHeaderNavigation extends Menu {
  constructor(element) {
    super(element)

    this.header = document.querySelector('.js-header')
    window.addEventListener('click', (event) => {
      if (
        this.instance.active &&
        (this.header.contains(event.target) == false ||
          event.target.hasAttribute('data-pointer-event-none'))
      ) {
        this.instance.closePopup(false)
      }
    })
  }
}
